import { useState } from 'react'
import styles from '../InternalExternalDetail.module.css'
import Icon from './Icon'
import Button from './Button'

const ContactList = ({ items }) => {
  const [copiedKey, setCopiedKey] = useState(null)

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
      setCopiedKey(text)
      setTimeout(() => setCopiedKey(null), 1200)
    } catch (err) {
      console.error('Copy failed:', err)
    }
  }

  return (
    <div className={styles.contactList}>
      {items.map((item) => (
        <div key={`${item.icon}-${item.text}`} className={styles.contactRow}>
          {item.blurred ? (
            <div
              className={`${styles.contactLink} ${styles.blurredContact}`}
              aria-label={`${item.icon === 'mail' ? 'Email' : 'Mobile number'} hidden`}
            >
              <span className={styles.contactIcon}>
                <Icon name={item.icon} />
              </span>
              <span className={styles.contactText}>{item.text}</span>
            </div>
          ) : (
            <a
              className={styles.contactLink}
              href={item.href}
              target={item.href.startsWith('http') ? '_blank' : undefined}
              rel={item.href.startsWith('http') ? 'noreferrer' : undefined}
            >
              <span className={styles.contactIcon}>
                <Icon name={item.icon} />
              </span>
              <span className={styles.contactText}>{item.text}</span>
            </a>
          )}

          {!item.blurred && <Button
            variant="copyBtn"
            onClick={() => handleCopy(item.text)}
            aria-label="Copy"
            title="Copy"
          >
            {copiedKey === item.text ? '✓' : <Icon name="copy" />}
          </Button>}
        </div>
      ))}
    </div>
  )
}

export default ContactList
